import React from 'react';
export default React.createContext(null);


//////////////////
// WEBPACK FOOTER
// ./~/react-alert/~/react-transition-group/esm/TransitionGroupContext.js
// module id = 284
// module chunks = 0